import { render, staticRenderFns } from "./yxCenter.vue?vue&type=template&id=611a8b62&scoped=true&"
import script from "./yxCenter.vue?vue&type=script&lang=js&"
export * from "./yxCenter.vue?vue&type=script&lang=js&"
import style0 from "./yxCenter.vue?vue&type=style&index=0&id=611a8b62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611a8b62",
  null
  
)

export default component.exports